import { Heading } from '@portal/components'
import { Container } from 'components/layout'

import { useEmployeeGroupContext } from './context'

export default function EmployeeGroupHeader() {
  const { name } = useEmployeeGroupContext()

  return (
    <div className="bg-background">
      <Container>
        <div className="flex flex-col justify-between pb-6 pt-4 lg:flex-row">
          <div className="mb-4 lg:mb-0">
            <Heading level={1} data-testid="employee-group-name">
              {name}
            </Heading>
            <p className="font-sans text-base text-foreground-subtle">
              Employee group
            </p>
          </div>
        </div>
      </Container>
    </div>
  )
}
